import type { HTMLAttributes, ReactNode } from "react";
import { injectCss } from "../core/injectCss";

const CSS = `
.js-snav{display:flex;flex-direction:column;gap:2px;font-family:var(--font-sans)}
.js-snav__group{font-size:var(--text-micro);font-weight:var(--weight-bold);letter-spacing:.06em;
  color:var(--text-subtle);text-transform:uppercase;padding:14px 12px 6px}
.js-snav__item{
  display:flex;align-items:center;gap:11px;cursor:pointer;text-decoration:none;
  font-size:var(--text-body);font-weight:var(--weight-semibold);color:var(--text-body);
  padding:9px 12px;border-radius:var(--radius-md);border:none;background:transparent;width:100%;text-align:left;
  transition:background var(--dur-fast) var(--ease-out),color var(--dur-fast) var(--ease-out);
}
.js-snav__item:hover{background:var(--neutral-100);color:var(--text-strong)}
.js-snav__item--active{background:var(--brand-subtle);color:var(--teal-700);font-weight:var(--weight-bold)}
.js-snav__item--active:hover{background:var(--brand-subtle)}
.js-snav__icon{display:flex;flex:none;width:20px;height:20px;align-items:center;justify-content:center;color:currentColor}
.js-snav__label{flex:1;min-width:0}
.js-snav__badge{font-size:var(--text-micro);font-weight:var(--weight-bold);background:var(--accent);color:#fff;
  padding:1px 7px;border-radius:var(--radius-pill);font-variant-numeric:tabular-nums}
.js-snav__item--active .js-snav__badge{background:var(--teal-600)}
`;

export interface SidebarItem {
  value?: string;
  label?: ReactNode;
  icon?: ReactNode;
  badge?: ReactNode;
  group?: ReactNode;
}

export interface SidebarNavProps extends Omit<HTMLAttributes<HTMLElement>, "onChange"> {
  items: SidebarItem[];
  value?: string;
  onChange: (v: string) => void;
}

export function SidebarNav({ items = [], value, onChange, className = "", ...rest }: SidebarNavProps) {
  injectCss("js-snav-css", CSS);
  return (
    <nav className={["js-snav", className].filter(Boolean).join(" ")} {...rest}>
      {items.map((it, i) =>
        it.group ? (
          <div key={`g${i}`} className="js-snav__group">
            {it.group}
          </div>
        ) : (
          <button
            key={it.value}
            type="button"
            className={["js-snav__item", it.value === value ? "js-snav__item--active" : ""].join(" ")}
            onClick={() => onChange(it.value!)}
          >
            <span className="js-snav__icon">{it.icon}</span>
            <span className="js-snav__label">{it.label}</span>
            {it.badge != null && <span className="js-snav__badge">{it.badge}</span>}
          </button>
        )
      )}
    </nav>
  );
}
